import { Spin, Alert } from 'antd';
import React, { useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import FileListItem from './components/FileListItem/FileListItem';
import NoticeListItem from './components/NoticeListItem/NoticeListItem';
import UploadDebtsFile from './components/UploadDebtsFile';
import './LeftBlockContainer.scss';
import getNoticesPreview from '../../store/thunks/getNoticesPreview';
import useFilesQuery from '../../hooks/useFilesQuery';
import actions from '../../store/actions/actions';
import UploadByHoustingStock from './components/UploadByHoustingStock/UploadByHoustingStock';

const LeftBlockContainer = ({ height }) => {
  const dispatch = useDispatch();

  const { data = [], isFetching } = useFilesQuery();

  useEffect(() => {
    if (data) {
      dispatch({
        type: actions.FILE_LIST_LOADED,
        payload: data,
      });
    }
  }, [dispatch, data]);

  const {
    params: { fileId },
  } = useRouteMatch('/Debts/file/:fileId') || { params: {} };

  const files = useSelector((store) => store.debtsStore.files);

  useEffect(() => {
    if (fileId && files?.length) {
      dispatch(getNoticesPreview(fileId));
    }
  }, [fileId, files?.length]);

  return (
    <div
      style={{ height }}
      className="left-block-list"
    >
      <div className="header">
        <span className="header-title">Загрузки</span>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <UploadDebtsFile />
          <UploadByHoustingStock />
        </div>
      </div>
      {isFetching ? (
        <Spin style={{ height, marginTop: '50%' }} />
      ) : !files?.length ? (
        <Alert
          type="info"
          icon
          description="Нет файлов"
        />
      ) : (
        <div className="debts-content-custom">
          {files?.map((file) => {
            return (
              <Fragment key={`list-item-${file.fileId}`}>
                <Link
                  to={`/Debts/file/${file.fileId}`}
                  key={`file-item-${file.fileId}`}
                >
                  <FileListItem file={file} />
                </Link>
                {+fileId === +file.fileId &&
                  file.notices?.length > 0 &&
                  file.notices.map((notice) => {
                    if (+notice.fileId === +fileId) {
                      return (
                        <Link
                          key={`notice-item-${notice.id}`}
                          to={`/Debts/file/${fileId}/notice/${notice.id}`}
                        >
                          <NoticeListItem notice={notice} />
                        </Link>
                      );
                    }
                  })}
              </Fragment>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LeftBlockContainer;
